import { render, staticRenderFns } from "./ClientDashboard.vue?vue&type=template&id=f42d0f54&scoped=true&"
import script from "./ClientDashboard.vue?vue&type=script&lang=js&"
export * from "./ClientDashboard.vue?vue&type=script&lang=js&"
import style0 from "./operations-dashboard.css?vue&type=style&index=0&id=f42d0f54&scoped=true&lang=css&"
import style1 from "./client-dashboard.css?vue&type=style&index=1&id=f42d0f54&scoped=true&lang=css&"
import style2 from "./ClientDashboard.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f42d0f54",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Users/joeldev/Developer/clientes/aduanas-pty/front-transit/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
installComponents(component, {VDialog,VIcon})
